export default __webpack_public_path__ + "dist/media/Sent-2.739fd0ef.svg";